import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'updateAccount'

export default ({
  Email,
  PowerBiReportId,
  PowerBiDataSetId,
  PowerBiUserName,
  PowerBiRole,
  PowerBiWorkspaceId,
  HidePowerBiFilter,
  HidePowerBiTabs,
}) =>
  asyncAction(name, AuthService.updateAccount, {
    Email,
    PowerBiReportId,
    PowerBiDataSetId,
    PowerBiUserName,
    PowerBiRole,
    PowerBiWorkspaceId,
    HidePowerBiFilter,
    HidePowerBiTabs,
  })

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/updateAccount.js